import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
const ACTIONS = {
    GET_MY_RECOMMEND_SUCCESS: 'GET_MY_RECOMMEND_SUCCESS',
    GET_MY_RECOMMEND_ERROR: 'GET_MY_RECOMMEND_ERROR',
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getRecommends = (tag_id, dimension_tag, player_id, team_id, count, pattern) => {
    const body = {};
    if (tag_id) {
        body["tag_id"] = tag_id;
    }
    if (dimension_tag) {
        body["dimension_tag"] = dimension_tag;
    }
    if (player_id) {
        body["player_id"] = player_id;
    }
    if (team_id) {
        body["team_id"] = team_id;
    }
    if (pattern) {
        body["pattern"] = pattern;
    }
    if (count) {
        body["count"] = count;
    }

    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`
        },
        body: JSON.stringify(body)
    };
    let url = `${host.recommend_server}recommend`;
    return (dispatch) => {
        return new Promise((resolve, reject) => {  // Return a promise from the action creator
            callApi(url, config,
                (data) => {
                    dispatch(updateStatus(ACTIONS.GET_MY_RECOMMEND_SUCCESS, data));
                    resolve(data);  // Resolve the promise with the data
                },
                (err) => {
                    dispatch(updateStatus(ACTIONS.GET_MY_RECOMMEND_ERROR, err));
                    reject(err);  // Reject the promise on error
                });
        });
    };
};

export {
    ACTIONS, getRecommends
};
